import {Component, inject, Input} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ColDef, GridApi, GridReadyEvent} from "ag-grid-community";
import {IPlayerSuspension} from "../../../interfaces/player/IPlayerSuspension";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {PlayerInfoTableDefs} from "../../player-game-info/player-info-table-defs";
import {PlayersService} from "../../../services/players.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MatDialog} from "@angular/material/dialog";
import {PermissionsService} from "../../../services/permissions.service";
import {SuspendPlayerComponent} from "../../dialogs/suspend-player/suspend-player.component";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IGamePlayerInputData} from "../../../interfaces/player/IGamePlayerInputData";
import {ActiveUserService} from "../../../services/active-user.service";
import {
  UpdatePlayerSuspensionStatusComponent
} from "../../dialogs/update-player-suspension-status/update-player-suspension-status.component";

@Component({
  selector: 'app-manage-player-suspensions',
  standalone: true,
  imports: [
    AgGridAngular,
    HasPermissionDirective,
    MatButton,
    MatIcon,
    MatProgressSpinner
  ],
  templateUrl: './manage-player-suspensions.component.html',
  styleUrl: './manage-player-suspensions.component.css'
})
export class ManagePlayerSuspensionsComponent {

  private playerInfoTables: PlayerInfoTableDefs = inject(PlayerInfoTableDefs);
  private playerService: PlayersService = inject(PlayersService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  private matDialog: MatDialog = inject(MatDialog);
  private permissionsService: PermissionsService = inject(PermissionsService);
  private activeUserService: ActiveUserService = inject(ActiveUserService);

  @Input()
  public suspensions: IPlayerSuspension[] = [];

  @Input()
  public set gamePlayerData(gamePlayerDataP: IGamePlayerInputData) {
    if (gamePlayerDataP.playerId && gamePlayerDataP.game.Id) {
      this.game = gamePlayerDataP.game;
      this.playerId = gamePlayerDataP.playerId;
    }
  }

  public playerSuspensionsColumnDefs: ColDef[] = this.playerInfoTables.playerSuspensionColumnDefs;
  public suspensionsApi!: GridApi<IPlayerSuspension>;
  public uiState = UIStateEnum.ShowData;
  public uiStateForTemplate = UIStateEnum;
  public game: IGameQueryResult | null = null;
  public playerId: string = '';

  protected readonly PermissionTypes = PermissionTypes;

  openSuspendPlayerDialog() {
    if (!this.permissionsService.userHasPermission(PermissionTypes.ModifyPlayerSuspensions)) {
      return;
    }
    this.matDialog.open(SuspendPlayerComponent, {
      data: {
        game: this.game,
        playerId: this.playerId
      },
      width: "650px"
    }).afterClosed().subscribe({
      next: (shouldSuspend) => {
        if (shouldSuspend) {
          this.playerService.fetchUpdatedSuspensionsSubject.next(true);
        }
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }

  onPlayerSuspensionsGridReady(params: GridReadyEvent<IPlayerSuspension>) {
    this.suspensionsApi = params.api;
    this.suspensionsApi.sizeColumnsToFit({
      defaultMinWidth: 100
    });
  }

  openPlayerSuspensionRowClick(chosenSuspension: any) {
    if (!this.permissionsService.userHasPermission(PermissionTypes.ModifyPlayerSuspensions)) {
      return;
    }

    if (chosenSuspension.data.CausableSuspension && !this.activeUserService.activeUser().CausableAdmin) {
      return;
    }

    this.matDialog.open(UpdatePlayerSuspensionStatusComponent, {
      data: {suspension: chosenSuspension.data, game: this.game},
      width: "650px"
    }).afterClosed().subscribe({
      next: (statusChanged) => {
        if (statusChanged) {
          this.playerService.fetchUpdatedSuspensionsSubject.next(true);
        }
      },
      error: err => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
